import { render, staticRenderFns } from "./ModificacionCertificacionDetallePage.vue?vue&type=template&id=8f40918c"
import script from "./ModificacionCertificacionDetallePage.js?vue&type=script&lang=js&external"
export * from "./ModificacionCertificacionDetallePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports